<template>
  <div class="staff-qr-code-container" @click="showQRCode = true">
    แสดง

    <a depressed class="btn-link" text color="primary">
      QR Code
    </a>

    สำหรับเจ้าหน้าที่

    <v-dialog v-model="showQRCode" max-width="420">
      <v-card class="modal-card">
        <div class="header-modal">
          <div class="title-modal">
            <div class="headline-l">
              QR Code สำหรับเจ้าหน้าที่
            </div>
          </div>
          <button class="btn-close" @click="showQRCode = false">
            <v-icon class="icon-close">
              mdi-close
            </v-icon>
          </button>
        </div>

        <div class="modal-content text-center">
          <div :class="['qr-code-box active my-4']">
            <qrcode-vue :value="deepLink" size="140"></qrcode-vue>
          </div>
          <p>
            รายการสั่งซื้อ <strong> #{{ orderCode() }} </strong>
            <br />
            กรุณานำ QR Code แสดงให้เจ้าหน้าที่
          </p>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'BaseStaffQrCode',

  inject: ['orderCode'],

  components: {
    QrcodeVue: () => import('qrcode.vue'),
  },

  data() {
    return {
      deepLink: `${window.location.origin}/confirm-payment/${this.$route.params.uid}`,
      showQRCode: false,
    }
  },
}
</script>

<style lang="stylus" scoped>
.staff-qr-code-container{
  font-size: 14px

  .btn-link {
	font-size: 14px
	font-weight: 600
  }
}

.qr-code-box
  background-color: #dedede
  width 140px
  height 140px
  margin 0 auto
  display flex
  justify-content center
  align-items center
  &.active {
	background-color: #fff
  }
  div {
	width: fit-content
	height: fit-content
  }
  .btn-show-qr-code {
    background-color: #000
	color: #fff
	width: fit-content
	height: auto
	padding: 8px
	aspect-ratio: 1 / 1
	border-radius: 50%
	display: flex;
    align-items: center;
	font-size: 12px;
	cursor: pointer;
  }

.header-modal {
    display: flex
    justify-content: space-between
    align-items: center
    margin-bottom: 16px
}

.modal-card {
    padding: 24px
    border-radius: 18px
}

.btn-close {
    width: 40px;
    height: 40px;
    min-width 40px

    background: #e8e8e8;
    border-radius: 50% !important;

    z-index 10

    &:hover {
        .icon-close {
            color: rgba(0,0,0,0.72)
        }
    }

    &:focus {
        outline: .125rem solid #0071e3;
        outline-offset: .125rem;
        outline-offset: .125rem;
    }

    .icon-close {
        color: rgba(18,18,18,0.56)
    }
}
</style>
